module.exports = __webpack_public_path__ + "static/media/casket.ea071932.png";